import API from "@unisearch/helpers/api";
import dynamic from "next/dynamic";
import { Fragment } from "react";

import { StudyLinks } from "@modules/study/country/study_why_country";

const StudyBannerTwo = dynamic(() =>
  import("@modules/study/country/study_banner_two")
);
const StudyBanner = dynamic(() =>
  import("@modules/study/country/study_banner")
);
const StudyVideo = dynamic(() => import("@modules/study/country/study_video"));
const StudyWhyCountryIntro = dynamic(() =>
  import("@modules/study/country/study_why_country/study_why_country_intro")
);

import { LayoutMain } from "@unisearch/theme/layout";
const ScrollPopup = dynamic(() => import("@unisearch/common/scroll_popup"), {
  ssr: false,
});

const Document = ({ pageData, document_type }) => {
  return (
    <Fragment>
      <LayoutMain
        isLeadPopup={true}
        footer_with_evaluation
        title={pageData?.pageTitle}
        metaTitle={pageData?.metaTitle || pageData?.pageTitle}
        metaKeywords={pageData?.metaKeyword || "unisearch, document"}
        metaDescription={
          pageData?.metaDescription ||
          "Apply to Universities Abroad with expert guidance from existing students"
        }
        metaImage={pageData?.featureImage?.src}
        metaUrl={`${process.env.NEXT_PUBLIC_URL}/document/${document_type}`}
      >
        <>
          {pageData && pageData?.videoType ? (
            <StudyBannerTwo
              pageData={pageData}
              name={document_type}
              linkType="document"
            />
          ) : (
            <StudyBanner
              pageData={pageData}
              name={document_type}
              linkType="document"
            />
          )}

          {(pageData?.videoupload !== null || pageData?.embedCode !== "") && (
            <StudyVideo pageData={pageData} />
          )}

          <StudyLinks
            linkType="document"
            name={document_type}
            pageData={pageData}
          />
          <StudyWhyCountryIntro
            linkType="document"
            name={document_type}
            pageData={pageData}
          />
        </>
      </LayoutMain>
      {/* <ScrollPopup /> */}
    </Fragment>
  );
};

export default Document;

export async function getServerSideProps({ params }) {
  const { document_type } = params;

  let props = {
    pageData: {},
    document_type: document_type,
  };

  try {
    const pageDetail = await API.get(
      `/public/page?pageType=document&slug=${document_type}`
    );
    if (!pageDetail.error && pageDetail.data) {
      props.pageData = pageDetail.data;
    } else {
      return {
        redirect: {
          permanent: false,
          destination: "/404",
        },
      };
    }

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
